import { createEnvelopeSource } from './create-envelope-source';

/** How many promotions the ranking carries. Five fills a `md` card without
 * scrolling and still reads as a ranking; the endpoint defaults to ten and
 * caps at fifty. */
const TOP_COUPON_LIMIT = '5';

/**
 * Top-redeemed-coupons KPI source. Pure config over the standardized envelope
 * (`GET /analytics/coupons/top-redeemed`): one scalar count of the period's
 * redemptions across every promotion, plus a `promotion` breakdown ranking the
 * highest-redeemed ones.
 *
 * `bars` renders the ranking as rows: the axis rows carry their own `rate` and
 * `base` (the share of the period total), so each promotion reads as a
 * percentage with the shared total in the card title. `pie` renders the same
 * rows as slices (the Overview's top-coupons donut, which raises the row count
 * to ten via the card-level `limit`).
 *
 * The rows are a truncated top-N: unlike the region axes, they do NOT sum to
 * the scalar, and the remainder is the rest of the catalog rather than a gap.
 * The card's own description carries that note: the endpoint records it as a
 * `caveat`, and the renderer shows only `warning` entries.
 *
 * Province is a filter here, not an axis: the ranking is the one inside the
 * selected region, so `regionGrain: 'province'` earns its place (the request
 * forwards `provinces`) without the source emitting a region breakdown.
 *
 * The same population as the whole-app redeemed scalar this one repeats, so
 * a card pairing the two cannot show a ranking under a total it is not part of.
 */
export const couponTopRedeemedSource = createEnvelopeSource({
    label: 'Top redeemed coupons',
    endpoint: 'analytics/coupons/top-redeemed',
    metrics: [
        {
            id: 'couponsRedeemed',
            label: 'Coupons redeemed',
            type: 'scalar',
        },
    ],
    forms: ['bars', 'pie'],
    regionGrain: 'province',
    staticParams: { limit: TOP_COUPON_LIMIT },
});
